import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Clock, Users, Star, BookOpen } from "lucide-react";
import { BadgePill } from "@/components/Brand";

export default function StudyCard({ study, index = 0 }) {
  const nav = useNavigate();
  const active = study.active;
  return (
    <button
      onClick={() => nav(`/study/${study.id}`)}
      data-testid={`study-card-${study.id}`}
      className="bp-fade-up group w-full rounded-2xl border border-[#E8E4DF] bg-white p-4 text-left transition-transform duration-200 hover:-translate-y-0.5 bp-card-shadow"
      style={{ animationDelay: `${Math.min(index * 60, 400)}ms` }}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="mb-1 flex flex-wrap items-center gap-2">
            <BadgePill tone="primary"><BookOpen size={12} /> {study.book}</BadgePill>
            {active ? (
              <BadgePill tone="sage"><Users size={12} /> Active</BadgePill>
            ) : (
              <BadgePill tone="warn"><Users size={12} /> Needs members</BadgePill>
            )}
          </div>
          <h3 className="font-display text-base font-semibold leading-snug text-[#0F3D66] group-hover:text-[#D94A3D]">
            {study.title}
          </h3>
        </div>
        {study.host_rating != null && (
          <span className="flex shrink-0 items-center gap-1 rounded-full bg-[#FDF6E9] px-2 py-1 text-xs font-semibold text-[#B4771E]">
            <Star size={12} fill="#E0A62B" color="#E0A62B" /> {study.host_rating}
          </span>
        )}
      </div>

      <div className="mt-3 space-y-1.5 text-sm text-[#6B6763]">
        <div className="flex items-center gap-2">
          <MapPin size={15} className="shrink-0 text-[#F36353]" />
          <span className="truncate">{study.venue.name} · {study.venue.category}</span>
        </div>
        <div className="flex items-center gap-2">
          <Clock size={15} className="shrink-0 text-[#748C70]" />
          <span>{study.schedule.day_name}s · {study.schedule.start_time} · {study.schedule.frequency}</span>
        </div>
      </div>

      <div className="mt-3 flex items-center justify-between border-t border-[#F0EBE4] pt-3 text-xs text-[#6B6763]">
        <span>{study.member_count} / min 3 members</span>
        {study.distance_km != null && <span className="font-medium text-[#0F3D66]">{study.distance_km} km away</span>}
      </div>
    </button>
  );
}
